import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ImageOverlay } from '../../../../elements/element/Image/ImageOverlay';
import ArchiveContainer from '../../../../../file/containers/ArchiveContainer';
import { deepClone } from '../../../../../helpers/objectHelper';
import { smallHeaderImageHandler } from './SmallHeaderImage.handler';
import { emailActions } from '../../../../../store/actions/cms/email/email.action';
import { HtmlWrapper } from '../../components/HtmlWrapper';
import InlineCropper from '../../../../../file/plugins/InlineCropper';
import './SmallHeaderImage.css'

const SmallHeaderImage = (props) => {
    const [mediaVaultOpen, openMediaVault] = useState(false)
    const { content, style } = props.element;
    const [isCropping, toggleCropper] = useState(false)
    const { template } = props;

    const setImage = (source) => {
        const { element, dispatch } = props;
        const updatedElement = deepClone(element);
        try {
            updatedElement.style.elementProps.source = source;
        } catch (error) {
            console.log('ERR: COULD NOT SET IMAGE')
        }
        updatedElement.content = smallHeaderImageHandler.elementEditor(updatedElement.style, null);
        props.dispatch(emailActions.updateEmailElement(updatedElement, null, true, props.inherit));
    }
    const onCrop = (value) => {
        setImage(value, false);
        toggleCropper(false)
    }
    const toggleMediaVault = (show) => {
        openMediaVault(show)
    }
    return (
        <React.Fragment>
            <tr>
                {isCropping ? <td>
                    <div
                        style={isCropping
                            ? { margin: '0px auto 0px auto' }
                            : {
                                width: !isCropping && 0,
                                opacity: !isCropping && 0,
                                height: !isCropping && 0,
                                maxHeight: style.styleProps.height
                            }
                        }
                    >
                        <InlineCropper
                            display={isCropping}
                            url={style.elementProps.source}
                            hideOverlay={true}
                            bgColor={
                                template &&
                                template &&
                                template.content.content.backgroundColor
                            }
                            mailCrop={true}
                            settings={{
                                type: 'FULL',
                                alignment: 'center',
                                style: {
                                    maxHeight: style.styleProps.height,
                                    width: 200
                                }
                            }}
                            containerStyle={{ height: style.styleProps.height, width: 200 }}
                            cancel={() => toggleCropper(!isCropping)}
                            parent={'contentId'}
                            isCropping={isCropping}
                            onSave={onCrop}
                        />
                    </div>
                </td> : null}
                {!isCropping ? <td className="email-image-wrapper">
                    <HtmlWrapper content={content} />
                    <ImageOverlay
                        toggleMediaVault={toggleMediaVault}
                        toggleCroppie={toggleCropper}
                        isCroppable={style.elementProps.source !== smallHeaderImageHandler.defaultStyle().elementProps.source}
                    />
                </td> : null}
            </tr>
            <tr>
                <td>
                    {mediaVaultOpen ?
                        <ArchiveContainer
                            isOpen={mediaVaultOpen}
                            onUseSelected={setImage}
                            showLaunchBtn={false}
                            toggle={toggleMediaVault} />
                        :
                        null}
                </td>
            </tr>

        </React.Fragment>
    )
}
function mapStateToProps(state) {
    return {
        state,
        inherit: state.email.inherit
    };
}

export default connect(mapStateToProps)(SmallHeaderImage);